import { faBorderAll, faStar, faTh } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import InternalRouter from "../components/elements/InternalRouter.Element";
import { InternalRoute } from "../interfaces/InternalRoute.Interface";
import EditTeamComponent from "../internal/myteam/EditTeam.Component";
import { ROUTES } from "../routes";
import "./MyTeam.Styles.scss";

export default function MyTeamScreen() {
  const routes: InternalRoute[] = [
    {
      icon: faBorderAll,
      route: ROUTES.teamCard,
      title: "Team Card",
    },
    {
      icon: faTh,
      route: ROUTES.changeTeamCard,
      title: "Change Team Card",
      component: EditTeamComponent,
    },
    {
      icon: faStar,
      route: ROUTES.ratePlayer,
      title: "Rate Player",
    },
  ];

  return (
    <div className="myteam-outer-container">
      <InternalRouter internalRoutes={routes} />
    </div>
  );
}
